module.exports = __webpack_public_path__ + "contractor_logo.2be5f87a.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/LiveChat/logos/contractor_logo.png
// module id = 2075
// module chunks = 0